import { Spine } from '@esotericsoftware/spine-pixi-v8';
// import { Texture } from "pixi.js";


// Define the mapping configuration
const symbolConfig: Record<number, { staticSymName: string; skeleton: string; atlas: string }> = {
    0: {
        staticSymName: "wildStatic",
        skeleton: "wildSkel",
        atlas: "wildAtlas"
    },
    1: {
        staticSymName: "lv4Static",
        skeleton: "lv4Skel",
        atlas: "lv4Atlas"
    },
    2: {
        staticSymName: "lv3Static",
        skeleton: "lv3Skel",
        atlas: "lv3Atlas"
    },
    3: {
        staticSymName: "lv2Static",
        skeleton: "lv2Skel",
        atlas: "lv2Atlas"
    },
    4: {
        staticSymName: "lv1Static",
        skeleton: "lv1Skel",
        atlas: "lv1Atlas"
    },
    5: {
        staticSymName: "hv4Static",
        skeleton: "hv4Skel",
        atlas: "hv4Atlas"
    },
    6: {
        staticSymName: "hv3Static",
        skeleton: "hv3Skel",
        atlas: "hv3Atlas"
    },
    7: {
        staticSymName: "hv2Static",
        skeleton: "hv2Skel",
        atlas: "hv2Atlas"
    },
    8: {
        staticSymName: "hv1Static",
        skeleton: "hv1Skel",
        atlas: "hv1Atlas"
    },
    12: {
        staticSymName: "scatterStatic",
        skeleton: "scatterSkel",
        atlas: "scatterAtlas"
    },
    13: {
        staticSymName: "special_symbolStatic",
        skeleton: "special_symbolSkel",
        atlas: "special_symbolAtlas"
    },
    100: {
        staticSymName: "",
        skeleton: "giantWildSkel",
        atlas: "giantWildAtlas"
    }
    // Add more mappings as needed
};

export function isOversizeSymbol(symbolIndex: number): boolean {

    // let isSymbolOversize = false;
    // if(symbolIndex == 0)// || symbolIndex == 9)
    // {
    //     isSymbolOversize=true;
    // }
    // return isSymbolOversize;


    let isSymbolOversize = false;
    if (symbolIndex == 0)// || symbolIndex == 9)
    {
        isSymbolOversize = false;
    }
    return isSymbolOversize;

}

export function isLandingAnimationExist(symbolIndex: number): boolean {

    // let isLandingExist = false;
    // if(symbolIndex == 0 || symbolIndex == 9)
    // {
    //     isLandingExist=true;
    // }
    // return isLandingExist;

    let isLandingExist = true;
    if (symbolIndex == 0 || symbolIndex == 9) {
        isLandingExist = true;
    }
    return isLandingExist;
}


// export function getSymbol(symbolIndex: number): Texture  {

//     let staticSymName: string = '';

//     const symbol = symbolConfig[symbolIndex];

//     if (symbol) {
//             staticSymName= symbol.staticSymName;
//     } 

//     const staticSymbol: Texture = Texture.from(staticSymName);
//     return staticSymbol;

// }

// import { Spine } from '@esotericsoftware/spine-pixi-v8';

export function getSpineSymbol(symbolIndex: number): Spine {
    const symbol = symbolConfig[symbolIndex];

    let skeletonVal: string = '';
    let atlasVal: string = '';

    if (symbol) {

        skeletonVal = symbol.skeleton;
        atlasVal = symbol.atlas;

        // console.log(skeletonVal);
        // console.log(atlasVal);

        // console.log(spineSymbol);

    }


    const spineSymbol: Spine = Spine.from({
        skeleton: skeletonVal,
        atlas: atlasVal,
        // skeleton: "lemonSkeleton",
        // atlas: "lemonAtlas",
    });

    // spineSymbol.update(1);

    // spineSymbol.state.setAnimation(0, "win", true);

    return spineSymbol;


}






